import { Uen } from "../modelo/Uen";
import { TransaccionSat } from "../modelo/TransaccionSat";
import { CatalogoGlosasSat } from "../modelo/CatalogoGlosasSat";

export const CONSULTAR_MAESTRO_UEN = "CONSULTAR_MAESTRO_UEN";
export const MAESTRO_UEN_CONSULTADO = "MAESTRO_UEN_CONSULTADO";
export const ERROR_CONSULTANDO_MAESTRO_UEN = "ERROR_CONSULTANDO_MAESTRO_UEN";

export const CONSULTAR_MAESTRO_TRANSACCIONES_SAT = "CONSULTAR_MAESTRO_TRANSACCIONES_SAT";
export const MAESTRO_TRANSACCIONES_SAT_CONSULTADO = "MAESTRO_TRANSACCIONES_SAT_CONSULTADO";
export const ERROR_CONSULTANDO_MAESTRO_TRANSACCIONES_SAT = "ERROR_CONSULTANDO_MAESTRO_TRANSACCIONES_SAT";

export const CONSULTAR_SERVICIOS_RECIBO_SAT = "CONSULTAR_SERVICIOS_RECIBO_SAT";
export const SERVICIOS_RECIBO_SAT_CONSULTADO = "SERVICIOS_RECIBO_SAT_CONSULTADO";
export const ERROR_CONSULTANDO_SERVICIOS_RECIBO_SAT = "ERROR_CONSULTANDO_SERVICIOS_RECIBO_SAT";

export const CONSULTAR_CATALOGO_GLOSAS_SAT = "CONSULTAR_CATALOGO_GLOSAS_SAT";
export const CATALOGO_GLOSAS_SAT_CONSULTADO = "CATALOGO_GLOSAS_SAT_CONSULTADO";
export const ERROR_CONSULTANDO_CATALOGO_GLOSAS_SAT = "ERROR_CONSULTANDO_CATALOGO_GLOSAS_SAT";

export const consultarMaestroUen = () => ({ type: CONSULTAR_MAESTRO_UEN });
export const maestroUenConsultado = (uenActivas: Array<Uen>) => ({ type: MAESTRO_UEN_CONSULTADO, uenActivas });
export const errorConsultadoMaestroUen = () => ({ type: ERROR_CONSULTANDO_MAESTRO_UEN });

export const consultarMaestroTransaccionesSat = () => ({ type: CONSULTAR_MAESTRO_TRANSACCIONES_SAT });
export const maestroTransaccionesSatConsultado = (transaccionesSat: Array<TransaccionSat>) => ({ type: MAESTRO_TRANSACCIONES_SAT_CONSULTADO, transaccionesSat });
export const errorConsultadoMaestroTransaccionesSat = () => ({ type: ERROR_CONSULTANDO_MAESTRO_TRANSACCIONES_SAT });

export const consultarServiciosReciboSat = () => ({ type: CONSULTAR_SERVICIOS_RECIBO_SAT });
export const serviciosReciboSatConsultado = (serviciosReciboSat: Array<TransaccionSat>) => ({ type: SERVICIOS_RECIBO_SAT_CONSULTADO, serviciosReciboSat });
export const errorConsultadoServiciosReciboSat = () => ({ type: ERROR_CONSULTANDO_SERVICIOS_RECIBO_SAT });

export const consultarCatalogoGlosasSat = () => ({ type: CONSULTAR_CATALOGO_GLOSAS_SAT });
export const catalogoGlosasSatConsultado = (catalogoGlosasSat: Array<CatalogoGlosasSat>) => ({ type: CATALOGO_GLOSAS_SAT_CONSULTADO, catalogoGlosasSat });
export const errorConsultandoCatalogoGlosasSat = () => ({ type: ERROR_CONSULTANDO_CATALOGO_GLOSAS_SAT });


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/modulos/maestrosActions.tsx